import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { change } from 'redux-form'
import ServicesComment from './ServicesComment'
import { resetServiceComment } from '../../actions'
import {
  APPOINTMENT_FORM_NAME
} from 'constant'
import model from '../../../viewModel'

const withLifecycle = lifecycle({
  componentDidMount() {
    const { value = '', change } = this.props

    value && change(APPOINTMENT_FORM_NAME, model.serviceComment.name, value)
  },
  componentWillUnmount() {
    const { resetServiceComment } = this.props
    resetServiceComment()
  }
})

export default compose(
  connect(null, { resetServiceComment, change }),
  withLifecycle
)(ServicesComment)
